import Unit from "@/src/utils/constants/units";
import { numberFormatter } from "helpers/number-formatter";

export const getQuickInfoList = (listingCardItems) => {
  if (!listingCardItems) return [];
  const { categoryTypeName, squareMeter, quickInfos } = listingCardItems;

  if (categoryTypeName === "Konut") {
    return [
      getQuickInfoValue(quickInfos, "room_count"),
      getQuickInfoValue(quickInfos, "floor_number"),
      `${numberFormatter(squareMeter)} ${Unit.M2.name}`,
    ];
  } else if (categoryTypeName === "Arsa") {
    return [getQuickInfoValue(quickInfos, "square")];
  } else if (categoryTypeName === "İşyeri") {
    return [getQuickInfoValue(quickInfos, "gross_square"), getQuickInfoValue(quickInfos, "floor_number")];
  } else if (categoryTypeName === "Turistik Tesis") {
    return [getQuickInfoValue(quickInfos, "total_area_square")];
  }
};

const getQuickInfoValue = (quickInfoList, key) => {
  return quickInfoList?.find((quickInfo) => quickInfo?.key === key)?.value || null;
};

export const mergedProjectAndListingList = ({ listingList, projectList, isProjectPage }) => {
  if (isProjectPage) {
    return projectList?.projectCards?.records || [];
  }
  const projectLocation = [2, 7, 12, 20, 27];
  const mergeList = [];
  let counter = 0;
  listingList.listingCard?.records?.forEach((item, index) => {
    mergeList.push(item);
    projectLocation.forEach((visible) => {
      if (visible === index && projectList?.projectCards?.records?.length > 0) {
        mergeList.push(projectList?.projectCards?.records[counter]);
        counter += 1;
      }
    });
  });
  return mergeList;
};
